import * as React from 'react'
import { gsap } from 'gsap'

import { useTimeDiff } from '../../../../../../../hooks/use-time-diff'

export const RepositoryFooter: React.FC<{
  latest: {
    icon: React.ReactNode
    message: string
    at: string
  }
}> = ({ latest }) => {
  const latestRef = React.useRef<HTMLParagraphElement>(null)
  const prevLatestRef = React.useRef<HTMLParagraphElement>(null)

  const timeDiff = useTimeDiff(new Date(latest.at))
  const [prevLatest, setPrevLatest] = React.useState(latest)

  React.useEffect(() => {
    if (
      !latestRef.current ||
      !prevLatestRef.current ||
      latest.at === prevLatest.at
    ) {
      return
    }

    const tl = gsap
      .timeline({ defaults: { duration: 0.26, ease: 'power1.out' } })
      .fromTo(
        prevLatestRef.current,
        { y: 0 },
        { y: -latestRef.current.offsetHeight - 16 }
      )
      .fromTo(
        latestRef.current,
        { y: latestRef.current.offsetHeight + 16 },
        { y: 0 },
        '<55%'
      )

    return () => {
      tl.kill()
      setPrevLatest((prevState) => prevState)
    }
  }, [latest.at, prevLatest.at])

  return (
    <div className="box-content overflow-hidden border-t border-dark-border-solid px-[19px] pt-[11px] pb-3">
      <div className="relative flex items-center justify-between">
        <div ref={latestRef} className="flex w-full justify-between">
          <p className="flex items-center space-x-1.5 overflow-hidden whitespace-nowrap text-xs leading-4 text-dark-muted">
            {latest.icon}
            <span className="overflow-hidden overflow-ellipsis">
              {latest?.message}
            </span>
          </p>
          <p className="whitespace-nowrap text-xs leading-4 text-dark-faint ml-2">
            {timeDiff}
          </p>
        </div>

        <div
          ref={prevLatestRef}
          className="absolute flex w-full justify-between"
        >
          <p className="flex w-full items-center space-x-1.5 overflow-hidden whitespace-nowrap text-xs leading-4 text-dark-muted">
            {prevLatest.icon}
            <span className="overflow-hidden overflow-ellipsis">
              {prevLatest?.message}
            </span>
          </p>
          <p className="whitespace-nowrap text-xs leading-4 text-dark-faint ml-2">
            {timeDiff}
          </p>
        </div>
      </div>
    </div>
  )
}
